import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListViewModeComponent } from './list-view-mode.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { SimpleToggleModule } from '../../../../../components/form-elements/simple-toggle/simple-toggle.module';

@NgModule({
  declarations: [ListViewModeComponent],
  imports: [CommonModule, SimpleToggleModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ListViewMode: {
          component: ListViewModeComponent,
        },
      },
    }),
  ],
})
export class ListViewModeModule {}
